<script>
import Base from '@/plans/VIDEO_SDK_UC/config/base';

export default {
  extends: Base,
};
</script>
